import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';
import * as api from '../api/settings';

const namespace = 'ANALYSIS';

export const FETCH_SALE_ANALYSIS_CONFIG = createRequestTypes(
  `${namespace}/FETCH_SALE_ANALYSIS_CONFIG`,
);

export const fetchSalesAnalysisConfig = makeApiActionCreatorV3(
  api.fetchSalesAnalysisConfig,
  FETCH_SALE_ANALYSIS_CONFIG[START],
  FETCH_SALE_ANALYSIS_CONFIG[SUCCESS],
  FETCH_SALE_ANALYSIS_CONFIG[ERROR],
);

export const UPDATE_SALE_ANALYSIS_CONFIG = createRequestTypes(
  `${namespace}/UPDATE_SALE_ANALYSIS_CONFIG`,
);

export const updateSalesAnalysisConfig = makeApiActionCreatorV3(
  api.updateSalesAnalysisConfig,
  UPDATE_SALE_ANALYSIS_CONFIG[START],
  UPDATE_SALE_ANALYSIS_CONFIG[SUCCESS],
  UPDATE_SALE_ANALYSIS_CONFIG[ERROR],
);

export const FETCH_SALES_ANALYSIS_TRANSITIONS_CODE_FILES = createRequestTypes(
  `${namespace}/FETCH_SALES_ANALYSIS_TRANSITIONS_CODE_FILES`,
);

export const fetchSalesAnalysisTransitionsCodefiles = makeApiActionCreatorV3(
  api.fetchSalesAnalysisTransitionsCodefiles,
  FETCH_SALES_ANALYSIS_TRANSITIONS_CODE_FILES[START],
  FETCH_SALES_ANALYSIS_TRANSITIONS_CODE_FILES[SUCCESS],
  FETCH_SALES_ANALYSIS_TRANSITIONS_CODE_FILES[ERROR],
);

export const FETCH_SALES_ANALYSIS_TRANSITIONS_MISSING_CODES = createRequestTypes(
  `${namespace}/FETCH_SALES_ANALYSIS_TRANSITIONS_MISSING_CODES`,
);

export const fetchSalesAnalysisTransitionsMissingCodes = makeApiActionCreatorV3(
  api.fetchSalesAnalysisTransitionsMissingCodes,
  FETCH_SALES_ANALYSIS_TRANSITIONS_MISSING_CODES[START],
  FETCH_SALES_ANALYSIS_TRANSITIONS_MISSING_CODES[SUCCESS],
  FETCH_SALES_ANALYSIS_TRANSITIONS_MISSING_CODES[ERROR],
);

export const FETCH_SALES_ANALYSIS_TRANSITIONS = createRequestTypes(
  `${namespace}/FETCH_SALES_ANALYSIS_TRANSITIONS`,
);

export const fetchSalesAnalysisTransitions = makeApiActionCreatorV3(
  api.fetchSalesAnalysisTransitions,
  FETCH_SALES_ANALYSIS_TRANSITIONS[START],
  FETCH_SALES_ANALYSIS_TRANSITIONS[SUCCESS],
  FETCH_SALES_ANALYSIS_TRANSITIONS[ERROR],
);

export const UPDATE_SALES_ANALYSIS_TRANSITIONS = createRequestTypes(
  `${namespace}/UPDATE_SALES_ANALYSIS_TRANSITIONS`,
);

export const updateSalesAnalysisTransition = makeApiActionCreatorV3(
  api.updateSalesAnalysisTransition,
  UPDATE_SALES_ANALYSIS_TRANSITIONS[START],
  UPDATE_SALES_ANALYSIS_TRANSITIONS[SUCCESS],
  UPDATE_SALES_ANALYSIS_TRANSITIONS[ERROR],
);

export const ADD_SALES_ANALYSIS_TRANSTION_MISSING_CODES = createRequestTypes(
  `${namespace}/ADD_SALES_ANALYSIS_TRANSTION_MISSING_CODES`,
);

export const addSalesAnalysisTransitionMissingCodes = makeApiActionCreatorV3(
  api.addSalesAnalysisTransitionMissingCodes,
  ADD_SALES_ANALYSIS_TRANSTION_MISSING_CODES[START],
  ADD_SALES_ANALYSIS_TRANSTION_MISSING_CODES[SUCCESS],
  ADD_SALES_ANALYSIS_TRANSTION_MISSING_CODES[ERROR],
);